import { observer } from "mobx-react";
import React from "react";
import { Redirect, Route, Switch, withRouter } from "react-router-dom";
import RoutesConstants from "../../constants/routes.constant";
import {
  findRouteAccess,
  redirectToDefaultRoute,
} from "../../helpers/route-helper";
import AccountActivation from "../../modules/account-activation/account-activation";
import AddEditAgreement from "../../modules/agreement-list/add-edit-agreement/add-edit-agreement";
import AgreementList from "../../modules/agreement-list/agreement-list";
import Login from "../../modules/auth/login";
import BookingManagement from "../../modules/booking-management/booking-management";
import CustomerManagement from "../../modules/customer-management/customer-management";
import CustomerLogin from "../../modules/customer-side/customer-auth/customer-login";
import ChangePassword from "../../modules/auth/password-reset/reset-password";
import customerRegistration from "../../modules/customer-side/customer-registration/customer-registration";
import Home from "../../modules/customer-side/home/home";
import StoreDetails from "../../modules/store-management/store-details/store-details";
import profile from "../../modules/customer-side/profile/profile";
import ForgetPassword from "../../modules/forget-password/components/forget-password";
import CategoryList from "../../modules/master-management/category-list/category-list";
import optionMenuList from "../../modules/master-management/option-menu-list/option-menu-list";
import ProductList from "../../modules/master-management/product-list/product-list";
import StaffInformation from "../../modules/master-management/staff-information/staff-information";
import StoreList from "../../modules/master-management/store-list/store-list";
import TreatmentList from "../../modules/master-management/treatment-list/treatment-list";
import NavigationMenu from "../../modules/navigation-menu-page/navigation-menu-page";
import ReservationList from "../../modules/reservation-management/reservation-list/reservation-list";
import ReservationListDetails from "../../modules/reservation-management/reservation-list/reservation-list-details";
import ReservationSettings from "../../modules/reservation-management/reservation-settings/reservation-settings";
import ShiftManagement from "../../modules/shift-management/shift-management";
import LayoutRoute from "../layout/layout-route";
import LoginLayoutRoute from "../layout/login-layout-route";
import storeTreatmentList from "../../modules/store-management/store-treatment-list/store-treatment-list";
import storeOptionMenuList from "../../modules/store-management/store-option-menu-list/store-option-menu-list";
import storeProductList from "../../modules/store-management/store-product-list/store-product-list";
import storeStaffInformation from "../../modules/store-management/store-staff-information/store-staff-information";
import SalesMedicalRecords from "../../modules/sales-medical-records/sales-medical-records";
import ReservationInformation from "../../modules/reservation-management/reservation-information/reservation-information";
import consumptionTax from "../../modules/consumption-tax/consumption-tax";
import uploadIcons from "../../modules/upload-icons-HQ/upload-icons";
import UploadTemplates from "../../modules/upload-templates-HQ/upload-templates";
import CancelationPolicy from "../../modules/cancelation-policy/cancelation-policy";
import ChangeAgreementPasswordPage from "../../modules/agreement-list/agreement-password-settings";
import { ModuleType } from "../../constants/enums/module-type-enum";
import { getUserTypeFromLocalStorage } from "../../helpers/localstorage-helper";
import userTypeEnum from "../../constants/enums/user-type-enum";
import timeSettings from "../../modules/master-management/master-settings/time-settings/time-settings";
import taxSettings from "../../modules/master-management/master-settings/tax-settings/tax-settings";
import businessTypeSettings from "../../modules/master-management/master-settings/business-type-settings/business-type-settings";
import storeMotivationSettings from "../../modules/master-management/master-settings/store-motivation-settings/store-motivation-settings";
import paymentSettings from "../../modules/master-management/master-settings/payment-settings/payment-settings";
import themeSettings from "../../modules/master-management/master-settings/theme-settings/theme-setting";
import headquarter from "../../modules/headquarter-management/headquarter";
import motivationInStore from "../../modules/motivation-in-store/motivation-in-store";
import paymentInStore from "../../modules/store-management/payment-in-store/payment-in-store";
import cancelledReservation from "../../modules/master-management/cancelled-reservation/cancelled-reservation";
import LizeraStoreDetailsComponent from "../../modules/cms/components/lizera-store-details";
import StoreCmsDetails from "../../modules/store-management/store-cms-details/store-cms-details";
import LizeraStoreList from "../../modules/customer-side/home/store-list";
import StoreDetailPage from "../../modules/customer-side/home/store-details";
import InventoryManagement from "../../modules/invertory-management/inventory-management";
import EmailManagement from "../../modules/email-management/email-management";
import Dashboard from "../../modules/dashboard/dashboard";
import TotallingManagementDaily from "../../modules/totalling-magagement/totalling-management-daily";
import TotallingManagementWeekly from "../../modules/totalling-magagement/totalling-management-weekly";
import TotallingManagementMonthly from "../../modules/totalling-magagement/totalling-management-monthly";
import TotallingManagementStaffSales from "../../modules/totalling-magagement/totalling-staff-details";
import TotallingManagementPeriod from "../../modules/totalling-magagement/totalling-management-period";
import resetPassword from "../../modules/auth/password-reset/reset-password";
import changePasswordAuth from "../../modules/auth/components/change-password-auth";
import AdminLogin from "../../modules/auth/login";
import StoreLogin from "../../modules/auth/store-login";
import StaffLogin from "../../modules/auth/staff-login";
import HeadQuarterLogin from "../../modules/auth/headquarter-login";
import GroupLogin from "../../modules/auth/group-login";
import InvalidStore from "../../modules/error/invalid-store";
import PageNotFound from "../../modules/error/page-not-found";

//import ReservationCalendar from "../../modules/reservation-management/reservation";

const RenderRoutes = () => {
  const userType = getUserTypeFromLocalStorage();
  return (
    <React.Fragment>
      <Switch>
        {/** Landing Pages Routes */}
        <LoginLayoutRoute
          path={RoutesConstants.CustomerRegistration}
          component={customerRegistration}
        />
        <LoginLayoutRoute
          path={RoutesConstants.CustomerLogin}
          component={CustomerLogin}
        />
        <LoginLayoutRoute
          path={RoutesConstants.CustomerLogin}
          component={CustomerLogin}
        />
        <LoginLayoutRoute
          path={RoutesConstants.AdminLogin}
          component={AdminLogin}
        />
        <LoginLayoutRoute
          path={RoutesConstants.StaffLogin}
          component={StaffLogin}
        />
        <LoginLayoutRoute
          path={RoutesConstants.StoreLogin}
          component={StoreLogin}
        />
        <LoginLayoutRoute
          path={RoutesConstants.HeadQuarterLogin}
          component={HeadQuarterLogin}
        />
        <LoginLayoutRoute
          path={RoutesConstants.GroupLogin}
          component={GroupLogin}
        />
        <Route
          path={RoutesConstants.ResetPassword}
          component={resetPassword}
        />

        <LoginLayoutRoute
          path={RoutesConstants.ChangePassword}
          component={changePasswordAuth}
        />
        {findRouteAccess(ModuleType.ReservationManagement) && (
          <LayoutRoute
            path={RoutesConstants.ReservationManagement}
            component={ReservationInformation}
          />
        )}
        <LayoutRoute
          path={RoutesConstants.CustomerBookingManagement}
          component={BookingManagement}
        />
        {/* <LoginLayoutRoute
          path={RoutesConstants.NavigationPage}
          component={NavigationMenu}
        /> */}

        <LoginLayoutRoute
          path={RoutesConstants.PageNotFound}
          component={PageNotFound}
        />

        <LoginLayoutRoute path={RoutesConstants.Home} component={Home} />
        {/* <LoginLayoutRoute path={RoutesConstants.Login} component={Login} /> */}
        {/**Customer LoggedIn Routes */}
        <LayoutRoute
          path={RoutesConstants.ReservationList}
          component={ReservationList}
        />
        <LayoutRoute
          path={RoutesConstants.LizeraStoreList}
          component={LizeraStoreList}
        />
        <Route
          path={RoutesConstants.StoreListPage}
          component={LizeraStoreList}
        />
        <LayoutRoute
          path={RoutesConstants.ReservationDetails}
          component={ReservationListDetails}
        />
        <LayoutRoute
          path={RoutesConstants.StoreDetails}
          component={StoreDetails}
        />
        <LayoutRoute path={RoutesConstants.Profile} component={profile} />
        {/**Admin side routes */}
        <LayoutRoute
          path={RoutesConstants.AccountActivation}
          component={AccountActivation}
        />
        
        <LayoutRoute
          path={RoutesConstants.LizeraStoreDetails}
          component={LizeraStoreDetailsComponent}
        />
        {findRouteAccess(ModuleType.ReservationManagement) && (
          <LayoutRoute
            path={RoutesConstants.SalesMedicalRecords}
            component={SalesMedicalRecords}
          />
        )}
        {/* <LayoutRoute path={RoutesConstants.Dashboard} component={Dashboard} /> */}
        {findRouteAccess(ModuleType.ReservationManagement) && (
          <LayoutRoute
            path={RoutesConstants.CustomerManagement}
            component={CustomerManagement}
          />
        )}
        {findRouteAccess(ModuleType.AgreementManegement) && (
          <LayoutRoute
            path={RoutesConstants.AgreementList}
            component={AgreementList}
          />
        )}
        {findRouteAccess(ModuleType.AgreementManegement) && (
          <LayoutRoute
            path={RoutesConstants.AgreementRegistration}
            component={AddEditAgreement}
          />
        )}
        {findRouteAccess(ModuleType.AgreementManegement) && (
          <LayoutRoute
            path={RoutesConstants.AgreementDetails}
            component={AddEditAgreement}
          />
        )}
        {findRouteAccess(ModuleType.StoreManagement) && (
          <LayoutRoute path={RoutesConstants.StoreList} component={StoreList} />
        )}
        {findRouteAccess(ModuleType.HeadquarterManagement) && (
          <LayoutRoute
            path={RoutesConstants.HeadquarterManagement}
            component={headquarter}
          />
        )}
        {findRouteAccess(ModuleType.TreatmentManagement) && (
          <LayoutRoute
            path={RoutesConstants.TreatmentList}
            component={TreatmentList}
          />
        )}
        {findRouteAccess(ModuleType.CategoryManagement) && (
          <LayoutRoute
            path={RoutesConstants.CategoryList}
            component={CategoryList}
          />
        )}
        {findRouteAccess(ModuleType.ProductManagement) && (
          <LayoutRoute
            path={RoutesConstants.ProductList}
            component={ProductList}
          />
        )}
        {findRouteAccess(ModuleType.StaffManagement) && (
          <LayoutRoute
            path={RoutesConstants.StaffInformation}
            component={StaffInformation}
          />
        )}
        {findRouteAccess(ModuleType.ReservationSetting) && (
          <LayoutRoute
            path={RoutesConstants.ReservationSettings}
            component={ReservationSettings}
          />
        )}
        {findRouteAccess(ModuleType.ShiftManagement) && (
          <LayoutRoute
            path={RoutesConstants.ShiftManagement}
            component={ShiftManagement}
          />
        )}
        {/* {
          findRouteAccess(ModuleType.Settings) &&
          <LayoutRoute path={RoutesConstants.Settings} component={SettingsPage} />
        } */}
        {findRouteAccess(ModuleType.OptionsManagement) && (
          <LayoutRoute
            path={RoutesConstants.OptionMenuList}
            component={optionMenuList}
          />
        )}
        {/* Store management route  */}
        {findRouteAccess(ModuleType.TreatmentManagement) &&
          userType === userTypeEnum[userTypeEnum.Store] && (
            <LayoutRoute
              path={RoutesConstants.StoreTreatmentList}
              component={storeTreatmentList}
            />
          )}
        {findRouteAccess(ModuleType.TreatmentManagement) &&
          userType === userTypeEnum[userTypeEnum.Store] && (
            <LayoutRoute
              path={RoutesConstants.StoreOptionMenuList}
              component={storeOptionMenuList}
            />
          )}
        {findRouteAccess(ModuleType.ProductManagement) &&
          userType === userTypeEnum[userTypeEnum.Store] && (
            <LayoutRoute
              path={RoutesConstants.StoreProductList}
              component={storeProductList}
            />
          )}
        {findRouteAccess(ModuleType.StaffManagement) &&
          userType === userTypeEnum[userTypeEnum.Store] && (
            <LayoutRoute
              path={RoutesConstants.StoreStaffInformation}
              component={storeStaffInformation}
            />
          )}
        {findRouteAccess(ModuleType.AgreementPasswordSetting) && (
          <LayoutRoute
            path={RoutesConstants.ChangeAgreementPassword}
            component={ChangeAgreementPasswordPage}
          />
        )}
        {findRouteAccess(ModuleType.ConsumptionTaxSetting) && (
          <LayoutRoute
            path={RoutesConstants.ConsumptionTax}
            component={consumptionTax}
          />
        )}
        {findRouteAccess(ModuleType.UploadIconsSetting) && (
          <LayoutRoute
            path={RoutesConstants.UploadIcons}
            component={uploadIcons}
          />
        )}
        {findRouteAccess(ModuleType.UploadTemplatesSetting) && (
          <LayoutRoute
            path={RoutesConstants.UploadTemplates}
            component={UploadTemplates}
          />
        )}
        {/* {findRouteAccess(ModuleType.UploadTemplatesSetting) && ( */}
        <LayoutRoute
          path={RoutesConstants.StoreCmsDetails}
          component={StoreCmsDetails}
        />
        <LayoutRoute
          path={RoutesConstants.CancelationPolicy}
          component={CancelationPolicy}
        />
        {/* )} */}
        {findRouteAccess(ModuleType.TaxSetting) && (
          <LayoutRoute
            path={RoutesConstants.TaxSettings}
            component={taxSettings}
          />
        )}
        {findRouteAccess(ModuleType.TimeSetting) && (
          <LayoutRoute
            path={RoutesConstants.TimeSettings}
            component={timeSettings}
          />
        )}
        {findRouteAccess(ModuleType.BusinessTypeManagement) && (
          <LayoutRoute
            path={RoutesConstants.BusinessTypeSettings}
            component={businessTypeSettings}
          />
        )}
        {findRouteAccess(ModuleType.StoreMotivationSetting) && (
          <LayoutRoute
            path={RoutesConstants.StoreMotivationSettings}
            component={storeMotivationSettings}
          />
        )}
        {findRouteAccess(ModuleType.PaymentModeSetting) && (
          <LayoutRoute
            path={RoutesConstants.PaymentModeSettings}
            component={paymentSettings}
          />
        )}
        <LayoutRoute
          path={RoutesConstants.ThemeInStore}
          component={themeSettings}
        />
        {findRouteAccess(ModuleType.StoreMotivationSetting) &&
          userType === userTypeEnum[userTypeEnum.Store] && (
            <LayoutRoute
              path={RoutesConstants.MotivationInStore}
              component={motivationInStore}
            />
          )}{" "}
        {findRouteAccess(ModuleType.PaymentModeSetting) &&
          userType === userTypeEnum[userTypeEnum.Store] && (
            <LayoutRoute
              path={RoutesConstants.PaymentInStore}
              component={paymentInStore}
            />
          )}
        {findRouteAccess(ModuleType.CancelledReservations) &&
          userType === userTypeEnum[userTypeEnum.Store] && (
            <LayoutRoute
              path={RoutesConstants.CancelledReservation}
              component={cancelledReservation}
            />
          )}
        {findRouteAccess(ModuleType.InventoryManagement) && (
          <LayoutRoute
            path={RoutesConstants.InventoryManagement}
            component={InventoryManagement}
          />
        )}
        {findRouteAccess(ModuleType.EmailManagement) && (
          <LayoutRoute
            path={RoutesConstants.EmailManagement}
            component={EmailManagement}
          />
        )}
        {findRouteAccess(ModuleType.TotallingManagement) && (
          <LayoutRoute
            path={RoutesConstants.TotallingManagementDaily}
            component={TotallingManagementDaily}
          />
        )}
        {findRouteAccess(ModuleType.TotallingManagement) && (
          <LayoutRoute
            path={RoutesConstants.TotallingManagementWeekly}
            component={TotallingManagementWeekly}
          />
        )}
        {findRouteAccess(ModuleType.TotallingManagement) && (
          <LayoutRoute
            path={RoutesConstants.TotallingManagementMonthly}
            component={TotallingManagementMonthly}
          />
        )}
        {findRouteAccess(ModuleType.TotallingManagement) && (
          <LayoutRoute
            path={RoutesConstants.TotallingManagementStaffSales}
            component={TotallingManagementStaffSales}
          />
        )}
        {findRouteAccess(ModuleType.TotallingManagement) && (
          <LayoutRoute
            path={RoutesConstants.TotallingManagementPeriodSales}
            component={TotallingManagementPeriod}
          />
        )}
        {findRouteAccess(ModuleType.Dashboard) && (
            <LayoutRoute
              path={RoutesConstants.Dashboard}
              component={Dashboard}
            />
        )}
        <Route
          path="/store/:storeCode/reservation"
          component={BookingManagement}
        />
        {/* {findRouteAccess(ModuleType.PaymentModeSetting) &&
          userType === userTypeEnum[userTypeEnum.Store] && ( */}
        <Route
          // path={RoutesConstants.LizeraStoreList}
          path="/store/:storeCode"  
          component={StoreDetailPage}
        />
        <Route
          path={RoutesConstants.InvalidStore}  
          component={InvalidStore}
        />
        {/* <Route
          path={RoutesConstants.LizeraStoreList}
          component={LizeraStoreList}
        /> */}
        {/* )} */}
        <Redirect to={redirectToDefaultRoute()} />
      </Switch>
    </React.Fragment>
  );
};

export default withRouter(observer(RenderRoutes));
